import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest, HttpEvent } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PlatformDetect } from '@libs/platform/platform-detect';
import { CommonService } from '@services/common/common.service';
import { FactoryService } from '@services/common/factory.service';
import { ComSubService } from '@services/common/com-sub.service';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {

    constructor(
        private comSer: CommonService,
        private platform: PlatformDetect,
        private factorySer: FactoryService,
        private comSubSer: ComSubService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        req = req.clone({
            headers: req.headers.set('X-platform', this.platform.detect()),
        });
        return next.handle(req).pipe(
            catchError((err: any) => {
                console.log('http interceptor...', 'err:',err,'err.status:',err?.status,'err.headers:',err?.headers)
                if (err instanceof HttpErrorResponse) { 
                    switch (err?.status) { 
                        //accessToken or refreshToken expired
                        case 401:
                        case 400:
                            return throwError(() => err);
                        case 429: //TYK limit err
                            const limitType = this.factorySer.getLimitType();
                            if (!this.factorySer.inLimit && limitType) {
                                this.factorySer.inLimit = true;
                                if (limitType === 'refresh') {
                                    this.comSubSer.refreshLoading(false);
                                    this.factorySer.errCode = '429';
                                    this.comSer.showErrorSub.next(true);
                                } else {
                                    this.factorySer.setToast(false, '2rem', null, 'Profile.Common.Limit.Toast.API');
                                }
                            }
                            this.factorySer.inLimit = false;
                            this.factorySer.setLimitType('');
                            return EMPTY;
                        case 499:
                            this.factorySer.errCode = '499';
                            this.comSer.showErrorSub.next(true);
                            return EMPTY;
                        case 404:
                            this.factorySer.errCode = '404-not found';
                            this.comSer.showErrorSub.next(true);
                            return EMPTY;
                        default:
                            this.factorySer.errCode = 'others';
                            this.comSer.showErrorSub.next(true);
                            return EMPTY;
                    }
                }
            }),
        );
    }
}